module.exports = __webpack_public_path__ + "img/people-39-min.202408f3.png";